import Big from 'big.js'
import {MoneyFormatOptions} from 'common/types'

export const roundNumber = (value: number, fractionDigits: number = 2): number => (
  Big(value).round(fractionDigits, Big.roundHalfUp).toNumber()
)

export const fixNumber = (value: number, fractionDigits: number = 2): number =>
  +value.toFixed(fractionDigits)

const initialMoneyFormatOptions: MoneyFormatOptions = {
  prefix: true,
  parentheses: false,
  cents: true,
}

export const formatMoney = (
  value: number,
  formatOptions?: MoneyFormatOptions
): string => {
  const options = formatOptions
    ? {...initialMoneyFormatOptions, ...formatOptions}
    : initialMoneyFormatOptions
  const centsCount = options.cents ? 2 : 0
  const money = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: centsCount,
  }).format(fixNumber(Math.abs(value), centsCount))
  const isNegative = value < 0
  return `${isNegative ? '-' : ''}${options.prefix ? '$' : ''}${
    options.parentheses ? `(${money})` : money
  }`
}

export const countPercentage = (count: number, total: number, fractionDigits = 1): number => {
  if (count === 0) return 0
  if (total === 0) return 100
  return fixNumber((count / total) * 100, fractionDigits)
}
